<template>
  <v-app>
    <v-snackbar
      v-for="toast in toasts"
      :key="toast.id"
      :color="toast.type"
      :timeout="toast.timeout"
      model-value="true"
      location="top right"
    >
      <div class="d-flex align-center justify-space-between w-100">
        <div>
          <strong v-if="toast.title">{{ toast.title }}</strong>
          <br v-if="toast.title" />
          <span>{{ toast.message }}</span>
        </div>
        <v-icon
          size="25"
          class="close-icon ml-2"
          @click="hideAndDeleteToast(toast.id)"
        >
          mdi-close-circle
        </v-icon>
      </div>
    </v-snackbar>
    <router-view />
    <CookieConsent />
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ApiInstanceService from "@/services/api/ApiInstanceService";
import CookieConsent from "@/components/CookieConsentManager.vue";
import Matomo from "@/utils/Matomo";
import ApiAuthService from "./services/api/ApiAuthService";

export default {
  components: { CookieConsent },
  data() {
    return {};
  },
  methods: {
    hideAndDeleteToast(id) {
      this.removeToast(id);
    },
    ...mapActions({
      removeToast: "toasts/remove",
      updateInstance: "instance/update",
      updateUser: "user/update",
      deleteUser: "user/delete",
    }),
    async checkUser() {
      try {
        const res = await ApiAuthService.me();
        if (res.data) {
          await this.updateUser(res.data);
        }
      } catch (err) {
        this.deleteUser();

        // Reset Matomo user identity
        Matomo.trackEvent(["resetUserId"]);
        Matomo.trackEvent(["setCustomDimension", 1, ""]);
      }
    },
    loadUsersnap() {
      window.onUsersnapLoad = function (api) {
        api.init();
      };
      const script = document.createElement("script");
      script.defer = true;
      script.src = `https://widget.usersnap.com/load/${process.env.VUE_APP_USERSNAP_API_KEY}?onload=onUsersnapLoad`;
      document.head.appendChild(script);
    },
  },
  computed: {
    ...mapGetters({
      toasts: "toasts/all",
      user: "user/getUser",
      instance: "instance/instance",
    }),
  },
  async mounted() {
    this.checkUser()
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme) {
      this.$vuetify.theme.global.name = savedTheme;
    }
    await this.updateInstance(await ApiInstanceService.getInstance(true));
  },
};
</script>

<style scoped lang="scss">
.close-icon {
  position: absolute !important;
  right: 0.5rem;
  top: 0.375rem;
  display: block;
}
</style>

<style lang="scss">
.theme--light.v-data-table thead th {
  background-color: #e5f5fc !important;
  &:first-child {
    border-radius: 25px 0 0 0;
  }
  &:last-child {
    border-radius: 0 25px 0 0;
  }
}
.theme--dark.v-data-table thead th {
  background-color: #282828 !important;
  &:first-child {
    border-radius: 25px 0 0 0;
  }
  &:last-child {
    border-radius: 0 25px 0 0;
  }
}

.theme--dark.v-data-table table {
  background-color: #282828 !important;
  border-radius: 25px !important;
}

.v-data-table tbody tr:not(:last-child) td {
  border-bottom: #5d5d5d solid 1px !important;
}

.v-data-table tbody tr:first-child td {
  border-top: #5d5d5d solid 1px !important;
}

.v-data-table {
  border-radius: 25px !important;
}

.v-data-table table tr:last-child:hover td:first-child {
  border-bottom-left-radius: 25px !important;
}

.v-data-table table tr:last-child:hover td:last-child {
  border-bottom-right-radius: 25px !important;
}

.v-data-table table tr:first-child:hover td:first-child {
  border-top-left-radius: 0 !important;
}

.v-data-table table tr:first-child:hover td:last-child {
  border-top-right-radius: 0 !important;
}
</style>
